import { createContext, useContext, useEffect, useState, useCallback } from "react";
import EndpointService from "@/services/agency/EndpointService";

const EndpointContext = createContext();

export const EndpointProvider = ({ children }) => {
    const [endpointObjects, setEndpointObjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const refresh = useCallback(() => {
        setIsLoading(true);
        EndpointService.getList()
            .then(data => setEndpointObjects(data))
            .finally(() => setIsLoading(false));
    }, []);

    const softRefresh = useCallback(() => {
        EndpointService.getList().then(data => setEndpointObjects(data));
    }, []);

    useEffect(() => { refresh(); }, []);

    return (
        <EndpointContext.Provider value={{ endpointObjects, isLoading, refresh, softRefresh }}>
            {children}
        </EndpointContext.Provider>
    );
};

export const useEndpointContext = () => useContext(EndpointContext);
